/* RRD Sauna Finder — 1 Sep 2026. Design pass 2 Sep 2026.
   Single writer: render() owns #rqz-stage entirely. Nothing else writes into it.
   No MutationObserver. No fixed positioning. Real radio inputs so arrow keys and
   screen readers work without any ARIA emulation. */
(function () {
  'use strict';
  var stage = document.getElementById('rqz-stage');
  var say   = document.getElementById('rqz-say');
  var fill  = document.getElementById('rqz-prog-fill');
  var root  = document.getElementById('rqz');
  if (!stage) return;

  var D = null;
  var S = { place: null, mode: null, cap: null, band: null };
  var autoBand = false;
  var kbNav = false, kbT = null, booting = true;
  var priceCache = {};
  /* imgFix: a card whose bundled image fails to load swaps to the product's current featured image, and the
     Klaviyo payload carries the working URL (21 Oct 2026: the FD-7 photo was replaced after the data build). */
  var imgFix = {};
  function absImg(u){ return !u ? "" : (u.indexOf("//")===0 ? "https:"+u : u); }

  var PLACES = [
    ['indoor',  'Indoors',  'Basement, spare room, garage or bathroom'],
    ['outdoor', 'Outdoors', 'Yard, deck or patio']
  ];
  var HEATDESC = {
    infrared:    'Warms you directly. 120 to 150°F. Most models run off a standard outlet.',
    trad_only:   'Rocks, stove and steam. 170 to 190°F. Needs a dedicated circuit.',
    hybrid_only: 'Stove and infrared in one cabin, used one at a time.',
    either:      'We will show you both.'
  };
  /* Outdoor infrared (SF-10, 28 Oct 2026): the outdoor infrared cabins we carry need their own 120V outlet or a 240V
     circuit, so the indoor line about a standard outlet would not be true here. */
  var HEATDESC_OUT = {
    infrared:    'Warms you directly and heats to about 140°F. Needs its own outlet or a 240V circuit, depending on the model.',
    either:      'We will show you all three.'
  };
  var CAPDESC  = {1:'A single bench', 2:'Two side by side', 3:'Room for a family', 5:'A group, or a light commercial room'};
  var EMFNAME  = {1:'Low EMF', 2:'Ultra Low EMF', 3:'Near Zero EMF'};
  var COMMERCIAL = 'Buying for a gym, spa, hotel or clinic? Sizing, power and warranty all work '
                 + 'differently. <a href="tel:+18885005675">Call (888) 500-5675</a> or read about '
                 + '<a href="/pages/commercial-sales">commercial sales</a>.';

  function el(h){ var d=document.createElement('div'); d.innerHTML=h.trim(); return d.firstChild; }
  function esc(s){ return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function money(n){ return '$'+Number(n).toLocaleString('en-US',{maximumFractionDigits:0}); }
  function key3(){ return S.place+'|'+S.mode+'|'+S.cap; }
  function key4(){ return key3()+'|'+S.band; }
  function bandsFor(){ return (D.tree[key3()]||[]); }

  function step(){
    if (!S.place) return 1;
    if (!S.mode || S.cap === null) return 2;
    if (!S.band) return 3;
    return 4;
  }

  /* ---------- URL state, so browser Back works and results are shareable ---------- */
  var SRC = '';
  try { SRC = new URLSearchParams(location.search).get('src') || ''; } catch(e){}

  /* ---------- email step before results (Idan, 25 Oct 2026) ----------
     The email box that sat under the results now sits between the budget question and the results, using the
     same Klaviyo calls (sendMatches below is unchanged), so the "Completed Sauna Finder" flow keeps working.
     Nobody is asked twice: a browser that already gave its email, or a visit from one of our own emails
     (Klaviyo adds _kx to tracked links; utm_medium=email / utm_source=klaviyo), goes straight to the results.
     Read here, before toURL() rewrites the address bar without those parameters. */
  var UNLOCK_KEY = 'rrd_sauna_finder_email_v1';
  var unlocked = false, sentTo = '';
  try { unlocked = localStorage.getItem(UNLOCK_KEY) === '1'; } catch(e){}
  try {
    var qp0 = new URLSearchParams(location.search);
    if (qp0.get('_kx') !== null || /email/i.test(qp0.get('utm_medium') || '') || /klaviyo/i.test(qp0.get('utm_source') || '')) unlocked = true;
  } catch(e){}
  function unlock(){ unlocked = true; try { localStorage.setItem(UNLOCK_KEY, '1'); } catch(e){} }
  /* ?email=reset clears that memory, so the email step can be tested again on one browser. */
  try { if (new URLSearchParams(location.search).get('email') === 'reset') { localStorage.removeItem(UNLOCK_KEY); unlocked = false; } } catch(e){}

  function toURL(replace){
    var q = [];
    if (SRC) q.push('src='+encodeURIComponent(SRC));
    if (S.place) q.push('v='+S.place);
    if (S.mode)  q.push('h='+S.mode);
    if (S.cap!==null) q.push('c='+S.cap);
    if (S.band)  q.push('b='+encodeURIComponent(S.band));
    var url = location.pathname + (q.length ? '?'+q.join('&') : '');
    try { history[replace?'replaceState':'pushState']({rqz:1}, '', url); } catch(e){}
  }
  function fromURL(){
    var p = new URLSearchParams(location.search);
    S.place = p.get('v'); S.mode = p.get('h');
    S.cap   = p.get('c')!==null ? parseInt(p.get('c'),10) : null;
    S.band  = p.get('b');
    /* A stale link from before a data rebuild must not strand anyone on an empty screen. */
    if (S.place && !D.q2[S.place]) { S.place=null; S.mode=null; S.cap=null; S.band=null; }
    if (S.mode && S.place && !D.q2[S.place].some(function(m){return m[0]===S.mode;})) { S.mode=null; S.band=null; }
    if (S.cap!==null && !D.caps.some(function(c){return c[0]===S.cap;})) { S.cap=null; S.band=null; }
    if (S.band && !bandsFor().some(function(b){return b.label===S.band;})) S.band=null;
    /* Deep links are about to become the main entry path, so rebuild autoBand from the URL state
       rather than assuming a render pass set it. */
    autoBand = !!(S.place && S.mode && S.cap!==null && bandsFor().length===1);
  }

  function opt(name,val,on,title,desc,count,onPick){
    var l = el('<label class="rqz-opt'+(on?' is-on':'')+'">'
      + '<input type="radio" name="'+name+'" value="'+esc(val)+'"'+(on?' checked':'')+'>'
      + '<span class="rqz-om"><span class="rqz-ot">'+esc(title)+'</span>'
      + (desc?'<span class="rqz-od">'+desc+'</span>':'') + '</span>'
      + (count!=null?'<span class="rqz-on">'+count+(count===1?' sauna':' saunas')+'</span>':'') + '</label>');
    var i = l.querySelector('input');
    var changed = 0;
    i.addEventListener('change', function(){ changed = Date.now(); if (kbNav) return; onPick(); });
    i.addEventListener('keydown', function(e){
      if (e.key!=='Enter' && e.key!==' ') return;
      kbNav=false;
      /* Only commit here if the native change did not already do it. Firing both pushed two
         history entries and broke browser Back for keyboard users. */
      setTimeout(function(){ if (Date.now()-changed > 60) onPick(); }, 0);
    });
    return l;
  }

  function trail(){
    var items=[];
    if (S.place) items.push(['Venue', PLACES.filter(function(p){return p[0]===S.place;})[0][1],
      function(){ S.place=null;S.mode=null;S.cap=null;S.band=null; }]);
    if (S.mode){
      var m=(D.q2[S.place]||[]).filter(function(x){return x[0]===S.mode;})[0];
      if (m) items.push(['Heat', m[1], function(){ S.mode=null;S.band=null; }]);
    }
    if (S.cap!==null){
      var c=D.caps.filter(function(x){return x[0]===S.cap;})[0];
      if (c) items.push(['Seats', c[1], function(){ S.cap=null;S.band=null; }]);
    }
    /* When only one price range exists we pick it for the user. Showing a chip for a choice they
       never made reads as if we decided something on their behalf; the range is stated on results. */
    if (S.band && !autoBand) items.push(['Budget', S.band, function(){ S.band=null; }]);
    if (!items.length) return null;
    var ul=el('<ul class="rqz-trail"></ul>');
    items.forEach(function(it){
      var li=document.createElement('li');
      var b=el('<button type="button" class="rqz-chip"><span>'+esc(it[1])+'</span><em>Edit</em></button>');
      b.setAttribute('aria-label','Change '+it[0]+', currently '+it[1]);
      b.addEventListener('click', function(){ it[2](); render(); });
      li.appendChild(b); ul.appendChild(li);
    });
    return ul;
  }

  function whyLines(c){
    /* A two-value seat range prints as the product page does ("seats 2 to 3"), not as its maximum (26 Oct 2026). */
    var out=[(c.cmin && c.cmin<c.cap) ? 'Seats '+c.cmin+' to '+c.cap+' people' : 'Seats up to '+c.cap+(c.cap===1?' person':' people')];
    if (c.x && c.x.length>=2) out.push('Footprint '+Math.round(c.x[0])+' × '+Math.round(c.x[1])+' in');
    if (c.emf) out.push(EMFNAME[c.emf]);
    if (out.length<3 && c.fs) out.push('Full spectrum heaters');
    if (out.length<3 && c.w)  out.push(c.w);
    if (out.length<3 && c.f)  out.push(c.f.charAt(0).toUpperCase()+c.f.slice(1)+' style');
    return out.slice(0,3);
  }

  /* The bundled price keeps the card from rendering blank; the store price is authoritative. */
  /* onPre (28 Oct 2026): preorder status is read LIVE from the same /products/<handle>.js call as the price, from its
     tags, because sunray/inventory_sync.py moves products on and off preorder between quiz rebuilds. */
  var preCache = {};
  function livePrice(handle,node,onPre){
    if (priceCache[handle]!=null){ node.textContent=money(priceCache[handle]); if (onPre) onPre(!!preCache[handle]); return; }
    fetch('/products/'+handle+'.js',{headers:{Accept:'application/json'}})
      .then(function(r){ return r.ok?r.json():null; })
      .then(function(j){
        if (!j || typeof j.price!=='number') return;
        priceCache[handle]=j.price/100;
        preCache[handle]=(j.tags||[]).indexOf('rrd-preorder')>-1;
        node.textContent=money(priceCache[handle]);
        if (onPre) onPre(preCache[handle]);
      }).catch(function(){});
  }

  function progress(st){
    if (!fill) return;
    fill.style.width = ({1:'33%',2:'66%',3:'100%',4:'100%'})[st] || '0%';
  }


  /* ---------- send the three matches by email ----------
     Never gates the results: the cards are already on screen when this renders. Fires a Klaviyo
     client-side event carrying the matches, so a Klaviyo flow can render exactly the three saunas
     this person saw without anything being hardcoded. Marketing consent is a separate, unticked
     box and only appears when a list id is configured, because sending someone their own results
     is not the same permission as adding them to a list. */
  var CFG = window.RRD_QUIZ_EMAIL || {};
  function answerProps(){
    var m=(D.q2[S.place]||[]).filter(function(x){return x[0]===S.mode;})[0];
    var c=D.caps.filter(function(x){return x[0]===S.cap;})[0];
    return {
      'Sauna Venue':    S.place==='outdoor'?'Outdoors':'Indoors',
      'Sauna Heat':     m?m[1]:S.mode,
      'Sauna Seats':    c?c[1]:S.cap,
      'Sauna Budget':   S.band,
      'Sauna Finder Url': location.href
    };
  }
  function matchPayload(list){
    return list.map(function(c,i){
      return {
        Rank: i+1,
        Label: i===0 ? 'Best match' : (c.l||'Also worth seeing'),
        Title: c.t,
        Vendor: c.v,
        Price: c.p,
        PriceFormatted: money(priceCache[c.h]!=null?priceCache[c.h]:c.p),
        Url: location.origin+'/products/'+c.h,
        ImageUrl: (function(u){ return u ? (u.indexOf('?')>-1?u+'&':u+'?')+'width=600' : ''; })(imgFix[c.h]||c.i),
        Seats: c.cap,
        Footprint: (c.x&&c.x.length>=2) ? Math.round(c.x[0])+' x '+Math.round(c.x[1])+' in' : '',
        Electrical: c.e || '',
        Emf: c.emf ? EMFNAME[c.emf] : '',
        Wood: c.w || ''
      };
    });
  }
  /* Klaviyo's /client/ REST endpoints do not allow a cross-origin POST from the browser: the
     preflight returns Access-Control-Allow-Methods: OPTIONS only, so the POST is blocked. Verified
     2 Sep 2026 (the same payload returns 202 server-side). The supported browser path is Klaviyo's
     own onsite script, which is already loaded on every page of this store. */
  function klaviyoReady(){
    var K = window.klaviyo;
    return K && typeof K.identify === 'function' && typeof K.track === 'function' ? K : null;
  }
  /* Consent lives on a list, and identify() does not touch lists. This writes the actual
     consent record. Public-key endpoint, designed for the browser. Failure here must never
     block the shortlist the visitor asked for, so it resolves either way. */
  function subscribe(email){
    if (!CFG.list || !CFG.key) return Promise.resolve('skipped');
    var body = { data: { type: 'subscription', attributes: {
        custom_source: 'Sauna Finder',
        profile: { data: { type: 'profile', attributes: {
          email: email,
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
        } } }
      }, relationships: { list: { data: { type: 'list', id: CFG.list } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id='+encodeURIComponent(CFG.key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-07-15' },
      body: JSON.stringify(body)
    }).then(function(r){ return r.ok ? 'subscribed' : 'failed:'+r.status; })
      .catch(function(){ return 'failed'; });
  }

  function sendMatches(email, optIn, list){
    var K = klaviyoReady();
    if (!K) return Promise.reject(new Error('klaviyo unavailable'));
    var answers = answerProps();
    var profile = { '$email': email };
    Object.keys(answers).forEach(function(k){ profile[k] = answers[k]; });
    profile['Sauna Finder Marketing Opt In'] = !!CFG.list;
    if (CFG.list) profile['$consent'] = ['email'];
    var props = {};
    Object.keys(answers).forEach(function(k){ props[k] = answers[k]; });
    props.Matches      = matchPayload(list);
    props['Match Count'] = list.length;
    /* Klaviyo's identify/track promises do not settle when its own script has decided not to track
       (bot detection, __kla_off, a consent tool). The call is fire-and-forget by design and the
       event is queued client-side, so a stall must not leave the visitor staring at "Sending...".
       Race it: if nothing has settled in 6s, treat it as sent, because from here it is. */
    subscribe(email);
    var call = Promise.resolve(K.identify(profile)).then(function(){
      return K.track(CFG.metric || 'Completed Sauna Finder', props);
    });
    var settled = false;
    return Promise.race([
      call.then(function(v){ settled = true; return v; }),
      new Promise(function(res){ setTimeout(function(){ if (!settled) res('queued'); }, 6000); })
    ]);
  }

  /* ---------- measurement ----------
     GA4 is already on the store (G-44SPTSMRG3) with gtag available, so the finder reports into the
     analytics the owner already reads rather than a second system. Everything here is anonymous:
     the answers chosen and the products shown, never an email address or anything about why someone
     wants a sauna. Fires into dataLayer too, so a future GTM tag can pick it up without a rebuild. */
  function track(name, params){
    var p = {}; for (var k in params) if (params[k] !== undefined && params[k] !== null) p[k] = params[k];
    if (SRC) p.src = SRC;
    p.finder = 'sauna';
    try { if (typeof window.gtag === 'function') window.gtag('event', name, p); } catch(e){}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({event:name}, p)); } catch(e){}
  }
  function answerSnapshot(){
    var m = S.mode ? (D.q2[S.place]||[]).filter(function(x){return x[0]===S.mode;})[0] : null;
    var c = S.cap!==null ? D.caps.filter(function(x){return x[0]===S.cap;})[0] : null;
    return { venue: S.place || undefined,
             heat: m ? m[1] : undefined,
             seats: c ? c[1] : undefined,
             budget: S.band || undefined };
  }
  var seenStep = {};
  function trackStep(st){
    if (seenStep[st]) return;      /* a re-render of the same step is not a new step */
    seenStep[st] = true;
    if (st === 1) track('finder_start', {});
    if (st < 4) track('finder_step', Object.assign({step: st}, answerSnapshot()));
  }

  function renderSave(list){
    if (CFG.on === false || !CFG.key || !list.length) return null;
    var n = list.length;
    var word = n===1 ? 'this one' : n===2 ? 'both' : 'all three';
    var allFoot = list.every(function(c){ return c.x && c.x.length>=2; });
    var allElec = list.every(function(c){ return !!c.e; });

    var box = el('<div class="rqz-save"></div>');
    var w = el('<div class="rqz-save__in-w"></div>');
    w.appendChild(el('<span class="rqz-save__t">'+(n===1?'Don&rsquo;t lose this sauna':'Don&rsquo;t lose your top '+n)+'</span>'));
    w.appendChild(el('<p class="rqz-save__d">Your answers got you to '+word
      +'. One email keeps '+(n===1?'it':'them')+', with everything you need to check before you order.</p>'));
    var ul = el('<ul class="rqz-save__list"></ul>');
    var one = n===1 ? 'this sauna' : 'each one';
    [ (allFoot ? 'The exact footprint and height of '+one : 'The full specification of '+one),
      (allElec ? 'The electrical supply '+one+' needs' : 'What '+one+' needs to run'),
      'Five things buyers wish they had checked first'
    ].forEach(function(t){ var li=document.createElement('li'); li.textContent=t; ul.appendChild(li); });
    w.appendChild(ul);

    var row = el('<div class="rqz-save__row"></div>');
    var input = el('<input class="rqz-save__in" type="email" inputmode="email" autocomplete="email" '
      + 'maxlength="254" placeholder="Your email address" aria-label="Your email address">');
    var btn = el('<button type="button" class="rqz-save__btn">Send it over</button>');
    row.appendChild(input); row.appendChild(btn); w.appendChild(row);
    var opt=null;
    if (CFG.list) {
      /* Everyone who submits is subscribed, because the flow sends more than the shortlist alone.
         Stating that here is what makes emails 2 and 3 honest rather than a bait, and submitting
         after reading it is the explicit action Klaviyo requires. No checkbox: it adds friction
         without adding consent. */
      w.appendChild(el('<p class="rqz-save__consent">We&rsquo;ll email your shortlist and occasional '
        + 'sauna guidance. Unsubscribe anytime.</p>'));
    }
    var msg = el('<p class="rqz-save__msg" role="status" aria-live="polite"></p>');
    w.appendChild(msg); box.appendChild(w);

    var busy = false;
    function fail(text){
      busy=false; btn.disabled=false; btn.textContent='Send it over';
      msg.className='rqz-save__msg is-err'; msg.textContent=text;
      input.setAttribute('aria-invalid','true');
    }
    function submit(){
      if (busy) return;
      var email=(input.value||'').trim();
      var EMAIL=/^[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/;
      if (!EMAIL.test(email) || email.length>254 || email.split('@')[0].length>64) {
        fail('That does not look like an email address. Check it and try again.');
        input.focus(); return;
      }
      busy=true; btn.disabled=true; btn.textContent='Sending\u2026';
      input.removeAttribute('aria-invalid');
      msg.className='rqz-save__msg'; msg.textContent='';
      sendMatches(email, !!(opt && opt.querySelector('input').checked), list)
        .then(function(){
          box.classList.add('is-done');
          msg.className='rqz-save__msg is-ok';
          /* Confirm, then point at the next step. The old wording ended on "if it has not arrived,
             call us", which plants doubt and hands someone a complaint route at the one moment they
             are pleased. */
          msg.textContent = 'On its way to '+email
            + '. Whenever you want to talk one of these through, a specialist is on (888) 500-5675.';
          track('finder_email', answerSnapshot());   /* the address itself is never sent to GA4 */
          announce('Your shortlist is on its way to '+email+'.');
        })
        .catch(function(){
          fail('We could not send that just now. Call (888) 500-5675 and we will send it over.');
        });
    }
    btn.addEventListener('click', submit);
    input.addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); submit(); } });
    return box;
  }

  function render(){
    /* A seat answer with no sauna behind it (outdoor infrared seats at most four, SF-10) would open an empty budget
       step, e.g. after changing the heat answer. Drop the seat answer so the shopper picks again on step 2. */
    if (S.place && S.mode && S.cap!==null && !bandsFor().length){ S.cap=null; S.band=null; autoBand=false; }
    /* Skip a budget question that has only one possible answer — it decides nothing. */
    if (!S.band && S.place && S.mode && S.cap!==null){
      var bs0=bandsFor();
      if (bs0.length===1){ S.band=bs0[0].label; autoBand=true; }
    }
    var st=step();
    var wrap=stage.parentNode;
    wrap.classList[st===4?'add':'remove']('is-results');
    if (root) root.classList[st===4?'add':'remove']('is-payoff');
    wrap.classList[st===1?'add':'remove']('is-start');
    progress(st);
    trackStep(st);
    if (!booting) toURL(false);

    stage.textContent='';
    var t=trail(); if (t) stage.appendChild(t);

    if (st>1){
      var back=el('<button type="button" class="rqz-back">← Back</button>');
      back.addEventListener('click', function(){
        /* If the budget step was auto-skipped there is nothing to go back TO: clearing the band
           just lets the auto-skip re-select it and we land on results again. Step back past it. */
        if (st===4){
          if (autoBand){ S.band=null; S.cap=null; autoBand=false; }
          else { S.band=null; }
        }
        else if (st===3){ S.band=null; S.cap=null; }
        else { S.place=null; S.mode=null; S.cap=null; }
        render();
      });
      stage.appendChild(back);
    }

    if (st===1){
      /* Start screen in the heater finder's layout (Idan, 25 Oct 2026): intro and question on the left, a lifestyle
         photo on the right; on a phone the photo sits under the choices. Same markup as the server-rendered copy. */
      var split=el('<div class="rqz-split"></div>'), main=el('<div class="rqz-split__main"></div>');
      main.appendChild(el('<div class="rqz-intro"><p class="rqz-eyebrow">Sauna finder</p><h1 class="rqz-h1">Find the right sauna for your space</h1>'
        +'<p class="rqz-lead">Three quick steps. We match your answers against the saunas we carry and show the best fits.</p></div>'));
      main.appendChild(el('<span class="rqz-count">Step 1 of 3</span>'));
      main.appendChild(el('<h2 class="rqz-legend" id="rqz-q1" tabindex="-1">Where will it go?</h2>'));
      main.appendChild(el('<p class="rqz-sub">This decides more than anything else you will tell us.</p>'));
      var f=el('<fieldset data-cols="2" aria-labelledby="rqz-q1"></fieldset>');
      PLACES.forEach(function(p){
        f.appendChild(opt('q1',p[0],S.place===p[0],p[1],p[2],D.counts[p[0]+'|either|1'],function(){
          S.place=p[0];S.mode=null;S.cap=null;S.band=null;autoBand=false;render();
        }));
      });
      main.appendChild(f);
      split.appendChild(main);
      if (window.RRD_QUIZ_HERO){
        var ph=el('<div class="rqz-split__photo"></div>'), pim=document.createElement('img');
        pim.src=window.RRD_QUIZ_HERO+(window.RRD_QUIZ_HERO.indexOf('?')>-1?'&':'?')+'width=1000';
        pim.alt=''; pim.width=1000; pim.height=667; pim.decoding='async';
        ph.appendChild(pim); split.appendChild(ph);
      }
      stage.appendChild(split);
      announce('Step 1 of 3. Where will it go?');
    }

    if (st===2){
      stage.appendChild(el('<span class="rqz-count">Step 2 of 3</span>'));
      var g1=el('<div class="rqz-grp"></div>');
      g1.appendChild(el('<h2 class="rqz-legend" id="rqz-q2" tabindex="-1">Which kind of heat?</h2>'));
      /* Outdoor line built from the live counts (SF-10, 28 Oct 2026). It used to say every outdoor sauna is stove heated,
         which stopped being true when SunRay's outdoor infrared cabins went live. */
      var outSub = '';
      if (S.place==='outdoor'){
        var tradN = D.counts['outdoor|trad_only|1']||0, hybridN = D.counts['outdoor|hybrid_only|1']||0,
            irN = D.counts['outdoor|infrared|1']||0, bits = [];
        if (hybridN) bits.push(hybridN+(hybridN===1?' adds':' add')+' infrared alongside the stove');
        if (irN) bits.push(irN+(irN===1?' heats':' heat')+' with infrared alone');
        outSub = ((tradN+hybridN > irN) ? 'Most of our outdoor saunas heat with a stove. ' : '')
          + (bits.length ? bits.join(', and ')+'.' : '');
      }
      g1.appendChild(el('<p class="rqz-sub">'+(S.place==='outdoor'
        ? outSub
        : 'The one thing worth reading up on before you choose.')+'</p>'));
      var f1=el('<fieldset data-cols="2" aria-labelledby="rqz-q2"></fieldset>');
      (D.q2[S.place]||[]).forEach(function(m){
        var hd = (S.place==='outdoor' && HEATDESC_OUT[m[0]]) || HEATDESC[m[0]];
        f1.appendChild(opt('q2',m[0],S.mode===m[0],m[1],hd,D.counts[S.place+'|'+m[0]+'|1'],function(){
          S.mode=m[0];S.band=null;autoBand=false;render();
        }));
      });
      g1.appendChild(f1); stage.appendChild(g1);

      var g2=el('<div class="rqz-grp"></div>');
      g2.appendChild(el('<h2 class="rqz-legend" id="rqz-q3" tabindex="-1">How many people at once?</h2>'));
      g2.appendChild(el('<p class="rqz-sub">Seating counts assume everyone sitting upright. If you want to lie down, size up one step.</p>'));
      var f2=el('<fieldset data-cols="2" aria-labelledby="rqz-q3"></fieldset>');
      D.caps.forEach(function(c){
        var n = S.mode ? D.counts[S.place+'|'+S.mode+'|'+c[0]] : null;
        var o = opt('q3',c[0],S.cap===c[0],c[1],(n===0?'None with this kind of heat':(CAPDESC[c[0]]||'')),n,function(){
          S.cap=c[0];S.band=null;autoBand=false;render();
        });
        /* No sauna behind this answer (SF-10): show it, but it cannot be picked. */
        if (n===0){ o.querySelector('input').disabled=true; o.setAttribute('aria-disabled','true');
          o.style.opacity='0.5'; o.style.cursor='default'; }
        f2.appendChild(o);
      });
      g2.appendChild(f2); stage.appendChild(g2);
      /* The commercial prompt belongs where the user has actually signalled it, not on screen one. */
      if (S.cap===5) stage.appendChild(el('<p class="rqz-com">'+COMMERCIAL+'</p>'));
      else if (!S.mode) stage.appendChild(el('<p class="rqz-com">Answer the heat question and the seating counts fill in.</p>'));
      announce('Step 2 of 3.');
    }

    if (st===3){
      var bs=bandsFor(), total=bs.reduce(function(a,b){return a+b.n;},0);
      stage.appendChild(el('<span class="rqz-count">Step 3 of 3</span>'));
      stage.appendChild(el('<h2 class="rqz-legend" id="rqz-q4" tabindex="-1">What are you looking to spend?</h2>'));
      stage.appendChild(el('<p class="rqz-sub">Built from the '+total
        +' saunas that match your first answers, so every range has something in it.</p>'));
      var f3=el('<fieldset aria-labelledby="rqz-q4"></fieldset>');
      bs.forEach(function(b){
        f3.appendChild(opt('q4',b.label,S.band===b.label,b.label,'',b.n,function(){
          S.band=b.label;autoBand=false;render();
        }));
      });
      stage.appendChild(f3);
      announce('Step 3 of 3. What are you looking to spend?');
    }

    /* The email step uses the centered question column, not the wide results grid (Idan, 25 Oct 2026). */
    var gated = st===4 && gateOn() && (D.paths[key4()]||[]).length > 0;
    wrap.classList[gated?'add':'remove']('is-gate');
    if (st===4){
      if (gated) renderGate(); else renderResults();
    }

    var lg=stage.querySelector('.rqz-legend');
    if (lg && !booting) { try{ lg.focus({preventScroll:true}); }catch(e){} }
  }

  function gateOn(){ return !unlocked && CFG.on !== false && CFG.gate !== false && !!CFG.key; }
  function gateImg(c){
    var im=document.createElement('img');
    im.src=c.i+(c.i.indexOf('?')>-1?'&':'?')+'width=320';
    im.alt=''; im.width=320; im.height=320; im.setAttribute('aria-hidden','true');
    im.onerror=function(){
      im.onerror=null;
      fetch('/products/'+c.h+'.js',{headers:{Accept:'application/json'}})
        .then(function(r){ return r.ok?r.json():null; })
        .then(function(j){ var u=absImg(j && j.featured_image); if (!u) return; imgFix[c.h]=u; im.src=u+(u.indexOf('?')>-1?'&':'?')+'width=320'; })
        .catch(function(){});
    };
    return im;
  }
  var gateSeen = {};
  function renderGate(){
    var list = D.paths[key4()] || [];
    var n = list.length;
    /* Live prices for the email, the same way the result cards fetch them. */
    list.forEach(function(c){ livePrice(c.h, document.createElement('span')); });
    if (!gateSeen[key4()]) { gateSeen[key4()] = true; track('finder_gate_view', Object.assign({ matches: n }, answerSnapshot())); }

    var allFoot = list.every(function(c){ return c.x && c.x.length>=2; });
    var allElec = list.every(function(c){ return !!c.e; });
    var one = n===1 ? 'this sauna' : 'each one';
    var top = n===1 ? 'your match' : 'your top&nbsp;'+n;

    stage.appendChild(el('<span class="rqz-count">Your matches are ready</span>'));
    stage.appendChild(el('<h2 class="rqz-legend" tabindex="-1">Where should we send '+top+'?</h2>'));
    stage.appendChild(el('<p class="rqz-sub">'+(n===1 ? 'We found the sauna that fits your answers.' : 'We found '+n+' saunas that fit your answers.')
      +' Enter your email and '+(n===1?'it opens':'they open')+' right here, with a copy in your inbox for when you measure up.</p>'));

    var box = el('<div class="rqz-gate"></div>');
    var peek = el('<div class="rqz-gate__peek" aria-hidden="true"></div>');
    peek.style.setProperty('--n', n);
    list.forEach(function(c,i){
      var f = el('<div class="rqz-gate__fig'+(i===0?' is-top':'')+'"></div>');
      var t = el('<div class="rqz-gate__tile"></div>');
      if (c.i) t.appendChild(gateImg(c));
      f.appendChild(t);
      f.appendChild(el('<span class="rqz-gate__tag">'+(i===0?'Best match':esc(c.l||'Also a fit'))+'</span>'));
      peek.appendChild(f);
    });
    box.appendChild(peek);

    var ul = el('<ul class="rqz-gate__list"></ul>');
    [ 'Why '+(n===1?'it fits':'each one fits')+' your space, from your own answers',
      (allFoot ? 'The exact footprint and height of '+one : 'The full specification of '+one),
      (allElec ? 'The electrical supply '+one+' needs' : 'What '+one+' needs to run')
    ].forEach(function(t){ var li=document.createElement('li'); li.textContent=t; ul.appendChild(li); });
    box.appendChild(ul);

    var row = el('<div class="rqz-gate__row"></div>');
    var input = el('<input class="rqz-gate__in" type="email" inputmode="email" autocomplete="email" '
      + 'maxlength="254" placeholder="Your email address" aria-label="Your email address">');
    var btn = el('<button type="button" class="rqz-gate__btn">Show my matches</button>');
    row.appendChild(input); row.appendChild(btn); box.appendChild(row);
    if (CFG.list) {
      box.appendChild(el('<p class="rqz-gate__consent">We&rsquo;ll email your shortlist and occasional '
        + 'sauna guidance. Unsubscribe anytime.</p>'));
    }
    var msg = el('<p class="rqz-gate__msg" role="status" aria-live="polite"></p>');
    box.appendChild(msg);
    box.appendChild(el('<p class="rqz-gate__tel">Rather talk it through? <a href="tel:+18885005675">Call (888) 500-5675</a></p>'));
    stage.appendChild(box);

    var busy = false;
    function fail(text){
      busy=false; btn.disabled=false; btn.textContent='Show my matches';
      msg.className='rqz-gate__msg is-err'; msg.textContent=text;
      input.setAttribute('aria-invalid','true');
    }
    function open(email, ok){
      unlock(); sentTo = ok ? email : '';
      busy=false; render();
      try { window.scrollTo({ top: 0 }); } catch(e){}
    }
    function submit(){
      if (busy) return;
      var email=(input.value||'').trim();
      var EMAIL=/^[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/;
      if (!EMAIL.test(email) || email.length>254 || email.split('@')[0].length>64) {
        fail('That does not look like an email address. Check it and try again.');
        input.focus(); return;
      }
      busy=true; btn.disabled=true; btn.textContent='Opening\u2026';
      input.removeAttribute('aria-invalid');
      msg.className='rqz-gate__msg'; msg.textContent='';
      sendMatches(email, false, list)
        .then(function(){
          track('finder_email', Object.assign({ where: 'gate' }, answerSnapshot()));   /* the address itself is never sent to GA4 */
          announce('Your matches are open, and a copy is on its way to '+email+'.');
          open(email, true);
        })
        .catch(function(){
          /* Klaviyo blocked (ad blocker, consent tool): never lock a buyer out of their own results. */
          track('finder_gate_error', answerSnapshot());
          open(email, false);
        });
    }
    btn.addEventListener('click', submit);
    input.addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); submit(); } });
    announce('Your matches are ready. Enter your email to see them.');
  }

  function renderResults(){
    /* The EMF filter is gone. We state on the page that low / ultra low / near zero have no agreed
       industry threshold behind them, so offering a filter on that scale contradicted our own
       disclaimer, and it showed no number a shopper could act on. The tier still appears as a
       reason line on each card for anyone who cares. */
    var cards = D.paths[key4()] || [];
    var show  = cards;
    var band  = bandsFor().filter(function(b){ return b.label===S.band; })[0];
    var pool  = band ? band.n : cards.length;

    if (!seenStep.results) {
      seenStep.results = true;
      track('finder_complete', Object.assign({
        matches: cards.length,
        products: cards.map(function(c){ return c.h; }).join(','),
        top_match: cards[0] ? cards[0].h : undefined
      }, answerSnapshot()));
    }
    stage.appendChild(el('<span class="rqz-count">Your matches</span>'));
    if (!show.length){
      stage.appendChild(el('<h2 class="rqz-legend" tabindex="-1">No saunas match these answers</h2>'));
      stage.appendChild(el('<p class="rqz-sub">Change an answer with the buttons above, or call a specialist and we will find one with you.</p>'));
    } else {
      stage.appendChild(el('<h2 class="rqz-legend" tabindex="-1">'
        +(show.length===1?'One sauna':show.length+' saunas')+' worth your time</h2>'));
      /* Once filtered, the sub-line has to describe what is actually on screen, not the
         unfiltered band total. */
      stage.appendChild(el('<p class="rqz-sub">'+(autoBand
        ? 'Every sauna matching your answers sits in one price range, '+esc(S.band).toLowerCase()
          +'. '+(pool===show.length ? (show.length===1 ? 'This is the only one' : 'These are all '+pool) : 'These are the best '+show.length+' of the '+pool)
          +'. The reasons under '+(show.length===1?'it':'each one')+' come from your own answers.'
        : (pool===show.length ? (show.length===1 ? 'The only sauna in that range' : 'All '+pool+' in that range, ranked on fit')
            : 'The best fits out of the '+pool+' in that range, ranked on fit')
          +'. The reasons under '+(show.length===1?'it':'each one')+' come from your own answers.')+'</p>'));
    }

    var grid=el('<div class="rqz-matches"></div>');
    show.forEach(function(c,i){
      var top=(i===0);
      var m=el('<div class="rqz-m'+(top?' rqz-m--top':'')+'"></div>');
      /* One amber badge only. Three identical badges destroy the hierarchy they exist to create. */
      if (top) m.appendChild(el('<span class="rqz-badge">Best match</span>'));
      else if (c.l) m.appendChild(el('<span class="rqz-badge rqz-badge--alt">'+esc(c.l)+'</span>'));
      var plate=el('<div class="rqz-mimg"></div>');
      if (c.i){
        var im=document.createElement('img');
        im.src=c.i+(c.i.indexOf('?')>-1?'&':'?')+'width=520';
        im.alt=c.t; im.loading='lazy'; im.width=520; im.height=390;
        im.onerror=function(){
          im.onerror=null;
          fetch('/products/'+c.h+'.js',{headers:{Accept:'application/json'}})
            .then(function(r){ return r.ok?r.json():null; })
            .then(function(j){
              var u=absImg(j && j.featured_image);
              if (!u) return;
              imgFix[c.h]=u;
              im.src=u+(u.indexOf('?')>-1?'&':'?')+'width=520';
              track('finder_image_fallback', { product: c.h });
            }).catch(function(){});
        };
        plate.appendChild(im);
      }
      m.appendChild(plate);
      m.appendChild(el('<span class="rqz-ven">'+esc(c.v)+'</span>'));
      m.appendChild(el('<h3>'+esc(String(c.t).split('|')[0].trim())+'</h3>'));
      var pn=el('<span class="rqz-p">'+money(c.p)+'</span>');
      /* Preorder note (Idan, 28 Oct 2026): same words as the product page box, "Preorder, ships <month>". The month is
         the product's custom.preorder_eta from the last rebuild (c.po); whether to show it is the live rrd-preorder tag. */
      var po=el('<span class="rqz-po" hidden style="display:none;align-self:flex-start;margin:-4px 0 11px;padding:4px 9px;'
        +'font-size:12.5px;font-weight:600;line-height:1.3;color:#6b5322;background:#fdf6e9;border:1px solid #f0dcb6;'
        +'border-radius:6px">'+esc('Preorder'+(c.po?', ships '+c.po:''))+'</span>');
      m.appendChild(pn); m.appendChild(po);
      livePrice(c.h,pn,function(on){ if (on){ po.hidden=false; po.style.display='inline-block'; } });
      var ul=el('<ul class="rqz-why"></ul>');
      whyLines(c).forEach(function(w){ var li=document.createElement('li'); li.textContent=w; ul.appendChild(li); });
      m.appendChild(ul);
      var cta=el('<a class="rqz-btn" href="/products/'+encodeURIComponent(c.h)+'">View this sauna</a>');
      cta.addEventListener('click', function(){
        track('finder_product_click', Object.assign({
          product: c.h, rank: i+1, price: c.p, label: i===0?'Best match':(c.l||'')
        }, answerSnapshot()));
      });
      m.appendChild(cta);
      grid.appendChild(m);
    });
    stage.appendChild(grid);
    /* No "browse all" link here (Idan, 20 Sep 2026): someone who just narrowed a hundred saunas down to three
       should not be handed the whole catalogue again. */

    /* One phone number on this screen, not two. The commercial line keeps its own destination
       but stops repeating the number sitting directly above it. */
    var cta=el('<div class="rqz-cta"></div>');
    cta.appendChild(el('<span class="rqz-cta__eyebrow">'+(show.length===1?'Not sure this one is right?':'Not sure which of these is right?')+'</span>'));
    cta.appendChild(el('<p>A specialist will size one with you, and tell you '
      +'straight if '+(show.length===1?'this one is not':'none of '+(show.length===2?'these two':'these three')+' is')+' right.</p>'));
    var tel=el('<a class="rqz-cta__tel" href="tel:+18885005675">Call (888) 500-5675</a>');
    tel.addEventListener('click', function(){ track('finder_call', answerSnapshot()); });
    cta.appendChild(tel);
    cta.appendChild(el('<p class="rqz-cta__sub">Buying for a gym, spa, hotel or clinic? '
      +'<a href="/pages/commercial-sales">Commercial sales</a> works differently on sizing, power and warranty.</p>'));
    if (sentTo){
      stage.appendChild(el('<p class="rqz-sent" role="status"><span>A copy of '+(show.length===1?'this sauna':'these '+show.length)
        +' is on its way to <b>'+esc(sentTo)+'</b>.</span></p>'));
    } else {
      var save=renderSave(show); if (save) stage.appendChild(save);
    }
    stage.appendChild(cta);
    var r=el('<button type="button" class="rqz-restart">Start over</button>');
    r.addEventListener('click', function(){
      track('finder_restart', answerSnapshot());
      S={place:null,mode:null,cap:null,band:null}; autoBand=false; seenStep={}; render();
    });
    stage.appendChild(r);
    announce(show.length+' matches found.'+(show[0]?' Top match, '+show[0].t+'.':''));
  }

  function announce(m){ if (say) say.textContent=m; }

  /* Arrow keys move focus AND fire change on radios. Without this guard a keyboard user is
     thrown to the next question on their first ArrowDown and can never finish. */
  document.addEventListener('keydown', function(e){
    if (/^Arrow/.test(e.key)){ kbNav=true; clearTimeout(kbT); kbT=setTimeout(function(){kbNav=false;},600); }
  });
  window.addEventListener('popstate', function(){ if (D){ fromURL(); booting=true; render(); booting=false; } });

  fetch(window.RRD_QUIZ_DATA_URL,{headers:{Accept:'application/json'}})
    .then(function(r){ if(!r.ok) throw new Error('data '+r.status); return r.json(); })
    .then(function(j){
      D=j; fromURL(); render(); toURL(true); booting=false;
    })
    .catch(function(){
      stage.appendChild(el('<div class="rqz-nojs" style="display:block"><h2>The finder could not load</h2>'
        +'<p>Sorry, something went wrong on our side. Browse '
        +'<a href="/collections/saunas">all saunas</a>, or call a specialist on '
        +'<a href="tel:+18885005675">(888) 500-5675</a> and we will size one with you.</p></div>'));
    });
})();
